var React = require('react');

function ExclamationCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 10.5C18 14.9183 14.4183 18.5 10 18.5C5.58172 18.5 2 14.9183 2 10.5C2 6.08172 5.58172 2.5 10 2.5C14.4183 2.5 18 6.08172 18 10.5ZM11 14.5C11 15.0523 10.5523 15.5 10 15.5C9.44772 15.5 9 15.0523 9 14.5C9 13.9477 9.44772 13.5 10 13.5C10.5523 13.5 11 13.9477 11 14.5ZM10 5.5C9.44772 5.5 9 5.94772 9 6.5V10.5C9 11.0523 9.44772 11.5 10 11.5C10.5523 11.5 11 11.0523 11 10.5V6.5C11 5.94772 10.5523 5.5 10 5.5Z","fill":"#EF4444"}));
}

ExclamationCircle.defaultProps = {"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none"};

module.exports = ExclamationCircle;

ExclamationCircle.default = ExclamationCircle;
